export const isElementInTargetPath = (
  element: HTMLElement,
  target: HTMLElement
): boolean => {
  if (element === target) {
    return true;
  } else if (!element.parentElement) {
    return false;
  }
  return isElementInTargetPath(element.parentElement, target);
};

export const findAncestorWithProperty = (
  element: Element,
  propertyName: string
) => {
  let result: Element | null = element;
  while (result && !(result as Record<string, any>)[propertyName]) {
    result = result.parentElement;
  }
  return result;
};

const generateElCssSelector = (el: Element) => {
  if (el === document.body) return 'body';
  const id = el.getAttribute('id');
  const classes = Array.from(el.classList)
    .map(className => `.${className}`)
    .join('');
  return id ? `#${id}` : `${el.tagName.toLowerCase()}${classes}`;
};

/** Generate CSS selector for el, starting at rootEl */
export const generateCssSelectorPath = (
  el: Element,
  rootEl: Element = document.body,
  currSelectors: string[] = []
): string => {
  const elSelector = generateElCssSelector(el);
  const parent = el.parentNode as HTMLElement;
  const newCurrSelectors = [...currSelectors, elSelector];

  if (!parent || el === rootEl) return newCurrSelectors.reverse().join(' > ');
  return generateCssSelectorPath(parent, rootEl, newCurrSelectors);
};
